import {
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormGroup,
  Grid,
  Paper,
  Snackbar,
  SnackbarContent,
  TextField,
  Tooltip,
} from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import "./EditoraFabricante.scss";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";
import * as React from "react";
import { Footer, Header, Navigation } from "../../shared";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import { useEffect, useState } from "react";
import { getError } from "../../../services/ErrorService";
import TableEditoraFabricante from "./TableEditoraFabricante";
import EditoraFabricanteForm from "./EditoraFabricanteForm";
import Rest from "src/services/Rest";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

function EditoraFabricante() {
  const [loading, setStateLoading] = useState<boolean>(false);
  const [listEditoras, setStateListEditoras] = useState([]);
  const [openForm, setStateOpenForm] = useState<boolean>(false);
  const [openDialog, setStateOpenDialog] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(undefined);
  const [filters, setStateFilters] = useState({
    editora: "",
    fabricante: "",
    page: 0,
    size: 10,
    total: 0,
  });
  const [alert, setStateAlert] = useState({
    message: "",
    open: false,
    type: "",
  });

  const openAlert = (msg: string, tipo: string) => {
    const item = { message: msg, type: tipo, open: true };
    setStateAlert(item);
  };

  const closeAlert = () => {
    const item = { message: "", type: "", open: false };
    setStateAlert(item);
  };

  const excluir = (item: any) => {
    setStateOpenDialog(true)
    setSelected(item)
  }

  const handleCancelDialog = () => {
    setStateOpenDialog(false)
    setSelected(undefined)
  }

  const handleConfirmationDialog = async () => {
    setStateOpenDialog(false)
    setStateLoading(true);
      if(!selected || !selected.id_dp || !selected.id_fabricante){
        return
      }
    const endPoint = `editora-fabricante/${selected.id_dp}`;
    await Rest.DELETE(endPoint, selected.id_fabricante)
    .then( data  => {
      if(data && data.data && data.data.errors != null && 
          data.data.errors !== undefined && data.data.errors.length > 0) {
        openAlert(data.data.errors[0].message, 'erro');
        setStateLoading(false)
      } else {
        openAlert('Relacionamento deletado com sucesso.', 'sucess');
        search(filters);
      }
    }).catch(err => {
      let errorMessage = 'Falha ao deletar relacionamento.';
      if(err != null && err !== undefined && 
        err.message !=null && err.message !== undefined && err.message !== "") {
        errorMessage = err.message;
      }
      openAlert(errorMessage, 'error');
      setStateLoading(false)
    });
  }

  const columns = [
    {
      render: (item: any) => <span>{item.id_dp}</span>,
      title: "Código Editora Simpleset",
    },
    {
      render: (item: any) => <span>{item.editora_dp}</span>,
      title: "Nome Editora Simpleset",
    },
    {
      render: (item: any) => <span>{item.id_fabricante}</span>,
      title: "Código Editora Bookinfo",
    },
    {
      render: (item: any) => <span>{item.fabricante}</span>,
      title: "Nome Editora Bookinfo",
    },
    {
      render: (item: any) => <span>{item.dta_criacao}</span>,
      title: "Data Inclusão",
    },

    {
      render: (item: any) => <span>{item.full_name}</span>,
      title: "Usuário Inclusão",
    },

    {
      render: (item: any) => (
        <>
          <IconButton
            component={"span"}
            onClick={() => excluir(item)}
            className="filter-dialog-close"
            color="secondary"
          >
            <Tooltip title="Excluir">
              <DeleteIcon />
            </Tooltip>
          </IconButton>  
        </>
      ),
      title: "Exlcuir",
    }
  ];

  const textFieldStyle = () => {
    return Object.assign({}, styles.textField);
  };

  const handleFilter = (ev: any, chave: string) => {
    const params = Object.assign({}, filters);
    params[chave] = ev.target.value;
    setStateFilters(params);
  };

  const handleChangePage = (ev: any, pageParam: number) => {
    const params = {
      editora: filters.editora,
      fabricante: filters.fabricante,
      page: pageParam,
      size: filters.size,
      total: filters.total,
    };
    search(params);
  };

  const handleClearFilter = () => {
    const params = {
      editora: "",
      fabricante: "",
      page: 0,
      size: 10,
      total: 0,
    };
    setStateFilters(params);
    search(params);
  };

  const search = async (filtro: any) => {
    setStateLoading(true);
    let endPoint = `editora-fabricante?page=${filtro.page}&size=${filtro.size}`;

    if (!!filtro.editora && filtro.editora !== "") {
      endPoint += `&editora=${filtro.editora}`;
    }

    if (!!filtro.fabricante && filtro.fabricante !== "") {
      endPoint += `&fabricante=${filtro.fabricante}`;
    }

    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setStateListEditoras(result.dados);
          const itens = filtro
          itens.total = result.total
          setStateFilters(itens)
        }
        setStateLoading(false);
      });
  };

    const closeForm = () =>{
      setStateOpenForm(false)
      search(filters);
    }

  useEffect(() => {
    search(filters);
  }, []);

  return (
    <div className="editora-fabricante-page">
      <Header
        title={"Editoras BookinfoXSimpleset"}
        name={"Administrativo"}
        link={"/dashboard"}
      />

      <Navigation
        name={"Editoras BookinfoXSimpleset"}
        linkDefault={"/administration/editora-fabricante"}
        link={"/dashboard"}
        linkTitle={"Produtos"}
        painel={3}
        icon={<StoreMallDirectoryIcon />}
      />

      <div className="editora-fabricante-body">
        <AdministrationMenu paramIcon={null} />

        <div className="wrapper">
          <Grid
            container={true}
            className="product-grouping-panel panel-grid"
            spacing={16}
          >
            <Grid item={true} xs={12}>
              <div>
                <Paper className="analytical-panel">
                  <Dialog
                    open={openDialog}
                    onClose={handleCancelDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{"Confirma a exclusão do item?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Após a exclusão de um item a operação não pode mais ser desfeita.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelDialog} color="secondary">
                            Cancelar
                        </Button>
                        <Button onClick={handleConfirmationDialog} color="primary" autoFocus={true}>
                            Confirmar
                        </Button>
                    </DialogActions>
                        </Dialog>
                  <Grid container={true} direction="column" spacing={16}>
                    {openForm ? (
                      <EditoraFabricanteForm closeForm={closeForm} />
                    ) : (
                      <Grid item={true}>
                        <Card>
                          <CardContent>
                            <Snackbar
                              anchorOrigin={{
                                horizontal: "center",
                                vertical: "center",
                              }}
                              open={alert.open}
                              autoHideDuration={4000}
                              onClose={closeAlert}
                            >
                              <SnackbarContent
                                message={alert.message}
                                style={styles[alert.type]}
                              />
                            </Snackbar>
                            <form>
                              <FormGroup row={true}>
                                <TextField
                                  id="standard-editoraSimpleset-input"
                                  label="Editora Simpleset"
                                  className="formTextField"
                                  style={textFieldStyle()}
                                  value={filters.editora}
                                  onChange={(ev) => handleFilter(ev, "editora")}
                                  type="text"
                                  margin="normal"
                                />
                                <TextField
                                  id="standard-editoraBookinfo-input"
                                  label="Editora Bookinfo"
                                  className="formTextField"
                                  style={textFieldStyle()}
                                  value={filters.fabricante}
                                  onChange={(ev) => handleFilter(ev, "fabricante")}
                                  type="text"
                                  margin="normal"
                                />
                              </FormGroup>
                            </form>
                          </CardContent>
                          <CardActions>
                            <Button
                              onClick={() => handleClearFilter()}
                              className="filter-dialog-close"
                            >
                              Limpar
                            </Button>
                            <Button
                              onClick={() => search(filters)}
                              className="filter-dialog-close"
                              color="primary"
                            >
                              Pesquisar
                            </Button>
                            <Button
                              onClick={() => setStateOpenForm(true)}
                              className="filter-dialog-close"
                              color="primary"
                            >
                              Novo Cadastro
                            </Button>
                          </CardActions>
                        </Card>
                        <Card>
                          <CardContent>
                            <TableEditoraFabricante
                              loading={loading}
                              rows={listEditoras}
                              columns={columns}
                              handleChangePage={handleChangePage}
                              tableProps={{
                                limit: filters.size,
                                page: filters.page,
                                total: filters.total,
                              }}
                            />
                          </CardContent>
                        </Card>
                      </Grid>
                    )}
                  </Grid>
                </Paper>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EditoraFabricante;



// WEBPACK FOOTER //
// ./src/component/administration/editoraFabricante/EditoraFabricante.tsx